import ListOfEssay from './ListOfEssay'
import OneEssay from './OneEssay'

const essay = { ListOfEssay, OneEssay }

export default essay
